import script from "./PhotoAlbum.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhotoAlbum.vue?vue&type=script&lang=ts&setup=true"

import "./PhotoAlbum.vue?vue&type=style&index=0&id=40caae1e&lang=scss"

const __exports__ = script;

export default __exports__